import {
  Modal,
  Form,
  Upload,
  Button,
  message as Message,
  Card,
  Input,
  Divider,
  Table,
  Row,
  Col,
  Select,
} from 'antd';
import { Provider, useSelector, useDispatch } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { store } from '../../store';
import i18n from 'i18next';
import { FaTrash } from 'react-icons/fa';
import { BsArrowLeftShort } from 'react-icons/bs';
import { UploadPhotoContent, getBase64 } from '../profile/CreateProfile';
import { getAppGlobalState } from '../../store/app-globals/selectors';
import { uploadAds, getAds, deleteAds } from '../../store/admin/actions';
import { setError, setLoading } from '../../store/app-globals/actions';
import { AdminNavbar } from '../layout/PageHeader';
import Column from 'antd/lib/table/Column';
import { useHistory } from 'react-router-dom';
import { colors } from '../../constants/colors';
import { getAdminState } from '../../store/admin/selector';

export const GlobalModalProps = {
  icon: null,
  false: true,
  maskClosable: true,
  className: 'modal-ads-container modal-ads-description',
  okButtonProps: { style: { display: 'none' } },
};

export const AddAdvertisement: React.FC = () => {
  const { isLoading, message, hasError } = useSelector(getAppGlobalState);
  const [image, setImage] = useState<string>('');
  const [position, setPosition] = useState<string>('');
  const dispatch = useDispatch();
  const normFile = (e: any): void => {
    getBase64(e.file.originFileObj, (imageUrl: string) => {
      setImage(imageUrl);
    });
    return e && e.fileList;
  };
  const isValidURL = (url: string) => {
    const res = url.match(
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
    );
    return res !== null;
  };

  const handleSelectPosition = (value: string) => {
    setPosition(value);
    console.log(value);
  };

  const onFormFinish = (values: any): void => {
    const body = {
      id: '',
      image: image,
      name: values.name,
      siteUrl: values.siteUrl,
      position: position,
    };
    if (!isValidURL(values.siteUrl)) {
      return;
    }
    if (position === '') {
      Message.error('Banner position is required.');
      return;
    }
    dispatch(uploadAds(body));
  };
  useEffect(() => {
    if (hasError) {
      Message.error(i18n.t('Something went wrong'));
      dispatch(setError(false, ''));
      return;
    }
    if (!isLoading && message) {
      Message.success(message);
      dispatch(setLoading(false, ''));
      setImage('');
    }
  }, [isLoading, message, hasError, dispatch]);
  return (
    <div>
      <span
        style={{ fontSize: '16px', fontWeight: 'bold', marginLeft: '20px' }}
      >
        Upload Advertisement Banner
      </span>
      <Form
        size="middle"
        name="create-meals"
        layout="vertical"
        // onFieldsChange={checker}
        onFinish={onFormFinish}
        // form={form}
        style={{ padding: '50px 100px 0 100px' }}
      >
        <Form.Item
          name="upload"
          valuePropName="fileList"
          getValueFromEvent={normFile}
          //   className="create-profile-form"
          rules={[{ required: true, message: i18n.t('IMAGE_UPLOAD_ERROR') }]}
        >
          <Upload.Dragger
            name="files"
            className="create-meals-upload"
            multiple={false}
            showUploadList={false}
          >
            {image ? (
              <img src={image} alt="avatar" style={{ width: '1000px' }} />
            ) : (
              <UploadPhotoContent image={image} />
            )}
          </Upload.Dragger>
        </Form.Item>
        <span>Banner Name</span>
        <Form.Item
          name="name"
          rules={[
            { required: true, message: 'Please input your banner name!' },
          ]}
        >
          <Input placeholder="Your Banner name" />
        </Form.Item>
        <span>Banner Website Url</span>
        <Form.Item
          name="siteUrl"
          rules={[
            { required: true, message: 'Please input your banner Site Url!' },
          ]}
        >
          <Input
            type="url"
            name="url"
            id="url"
            placeholder="https://example.com"
            pattern="https://.*"
            // required
          />
        </Form.Item>
        <span>Select Position of banner</span>
        <Form.Item required>
          <Select
            style={{ width: 200 }}
            placeholder="Select a Position"
            optionFilterProp="children"
            onChange={handleSelectPosition}
          >
            <Select.Option value="Top">Top position</Select.Option>
            <Select.Option value="Bottom">Bottom position</Select.Option>
            <Select.Option value="10th">10th position</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item>
          <Button
            style={{ float: 'right' }}
            htmlType="submit"
            loading={isLoading}
          >
            {message || 'Upload'}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export const AddAdvertisementHandler = () => {
  Modal.info({
    ...GlobalModalProps,
    style: { top: 30 },
    content: (
      <Provider store={store}>
        <AddAdvertisement />
      </Provider>
    ),
  });
};

export const Advertisement: React.FC = () => {
  const { advertisement } = useSelector(getAdminState);
  const { isLoading, message, hasError } = useSelector(getAppGlobalState);
  const dispatch = useDispatch();
  const history = useHistory();
  const getAdvertisement = () => {
    dispatch(getAds());
  };
  const handleClickDelete = (record: any) => {
    // window.open(record.image, '_blank');
    if (window.confirm('Are you sure you want to delete ?')) {
      dispatch(deleteAds(record.id));
    }
  };
  const handleAddButton = () => {
    AddAdvertisementHandler();
  };
  useEffect(() => {
    if (hasError) {
      Message.error(i18n.t('Something went wrong'));
      dispatch(setError(false, ''));
      return;
    }
    if (!isLoading && message) {
      Message.success(message);
      dispatch(setLoading(false, ''));
    }
  }, [isLoading, message, hasError, dispatch]);
  useEffect(getAdvertisement, []);
  return (
    <div className="admin">
      <Row justify="center">
        <AdminNavbar />
      </Row>
      <Col
        xs={24}
        sm={24}
        md={24}
        lg={24}
        style={{ alignSelf: 'center' }}
        className="manage-user-container"
      >
        <Card className="card2-wrap">
          <div className="card-header-wrap">
            <Row
              style={{
                alignItems: 'center',
                cursor: 'pointer',
                width: '200px',
              }}
              onClick={() => history.goBack()}
            >
              <BsArrowLeftShort size={32} color={colors.blue} />
              <span>Advertisement</span>
            </Row>
          </div>
          <div className="offer-search-input">
            <Input placeholder="Search Banner" />
          </div>
          <Button
            style={{
              backgroundColor: colors.blue,
              color: colors.white,
              paddingInlineStart: '40px',
              paddingInlineEnd: '40px',
              float: 'right',
              marginRight: '20px',
            }}
            onClick={handleAddButton}
          >
            <span>Add</span>
          </Button>
          <Divider type="vertical" />
          <div className="table-offers-wrap">
            <Table
              dataSource={advertisement}
              rowKey="image"
              style={{ padding: '20px' }}
            >
              <Column title="Name" dataIndex="name" key="name" />
              <Column title="Site Url" dataIndex="siteUrl" key="siteUrl" />
              <Column
                title="Banner Image Url"
                dataIndex="image"
                key="image"
                render={(text, record: any) => (
                  <Row justify="start">
                    <div
                      onClick={() => window.open(record.image, '_blank')}
                      style={{ cursor: 'pointer' }}
                    >
                      <span style={{ color: colors.blue }}>{record.image}</span>
                    </div>
                  </Row>
                )}
              />
              <Column
                title="Action"
                key="action"
                render={(text, record: any) => (
                  <Row justify="start">
                    <div
                      onClick={() => handleClickDelete(record)}
                      style={{ cursor: 'pointer' }}
                    >
                      <FaTrash color="#FF0000" size={20} />
                    </div>
                  </Row>
                )}
              />
            </Table>
          </div>
        </Card>
      </Col>
    </div>
  );
};
